import { initializeApp } from "firebase/app";
const firebaseConfig = {
    apiKey: "AIzaSyA0yeGHxpgbr_X5P7qQV_wwZ7F_TLQ5U0I",

    authDomain: "ss-app-b7b24.firebaseapp.com",

    databaseURL: "https://ss-app-b7b24.firebaseio.com",

    projectId: "ss-app-b7b24",

    storageBucket: "ss-app-b7b24.appspot.com",

    messagingSenderId: "109480449571",

    appId: "1:109480449571:web:f5ed30cfdd31e890d38396",

    measurementId: "G-TJHK1T6TH6"
}

const firebaseApp = initializeApp(firebaseConfig);

// const messaging = getMessaging()


// getToken(messaging, { vapidKey: process.env.PUBLIC_KEY_FIREBASE }).then((currentToken) => {
//     if (currentToken) {
//         console.log('fb token', currentToken)
//         setPushToken(currentToken)
//             // Send the token to your server and update the UI if necessary
//             // ...
//     } else {
//         // Show permission request UI
//         console.log('No registration token available. Request permission to generate one.');
//         // ...
//     }
// }).catch((err) => {
//     console.log('An error occurred while retrieving token. ', err);
//     // ...
// });